import type { IMessageShape } from './message';
import { Joi, objectSchemaOf } from '../helpers';

export const conversationMessagesParamsSchema = objectSchemaOf<IConversationMessagesParams>(
  {
    conversationId: Joi.string().required(),
  }
);

export interface IConversationMessagesParams {
  conversationId: string;
}

export type ConversationMessagesResult = IMessageShape[];
